export default __webpack_public_path__ + "static/media/popup-icons.ef9038fe.webp";